// The paper last chosen in "Print or save" (A4 or the 80 mm receipt), per device: a counter
// keeps printing receipts, an office keeps A4 (docs/plans/bill-logo.md).
import type { PrintFormat } from '../print.tsx'

const KEY = 'ims.printPaper'

export function readPrintChoice(): PrintFormat {
  try {
    return localStorage.getItem(KEY) === 'receipt' ? 'receipt' : 'a4'
  } catch {
    return 'a4'
  }
}

export function savePrintChoice(format: PrintFormat): void {
  try {
    localStorage.setItem(KEY, format)
  } catch {
    // Storage off (a private window): the dialog opens on A4.
  }
}

/** The two papers in a print menu's order: the one chosen last first, so Enter prints it. */
export function paperOrder(chosen: PrintFormat): PrintFormat[] {
  return chosen === 'receipt' ? ['receipt', 'a4'] : ['a4', 'receipt']
}
